// pro.rejouis.fr — historique du bon d'achat : crédits (rétrocommission, gestes de l'équipe)
// et utilisations sur les commandes, du plus récent au plus ancien.
import { fmtDate, fmtEuro } from './lib/api.js';
import { Icons, Retour } from './components/ui.jsx';

// Grille des taux : [part minimale de jouets reconditionnés sur le lot, taux de rétribution].
export function Paliers({ paliers }) {
  const lignes = [...paliers].reverse().map(([min, taux], i, t) => {
    const suivant = t[i + 1];
    const tranche = suivant ? (min === 0 ? `moins de ${Math.round(suivant[0] * 100)} %` : `${Math.round(min * 100)} à ${Math.round(suivant[0] * 100)} %`) : `${Math.round(min * 100)} % et plus`;
    return [tranche, `${Math.round(taux * 100)} %`];
  });
  return (
    <div className="card" style={{ padding: '12px 18px', marginBottom: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11.5 }} className="t-overline">
        <span>Jouets reconditionnés sur le lot</span><span>Votre part</span>
      </div>
      {lignes.map(([tranche, taux]) => (
        <div key={tranche} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderTop: '1px solid var(--bord)', fontSize: 14 }}>
          <span>{tranche}</span><b style={{ color: 'var(--bleu)' }}>{taux}</b>
        </div>
      ))}
    </div>
  );
}

export default function BonAchat({ partenaire, bons }) {
  const credits = bons.filter((b) => b.montant > 0).reduce((s, b) => s + b.montant, 0);
  const utilises = -bons.filter((b) => b.montant < 0).reduce((s, b) => s + b.montant, 0);
  return (
    <div className="anim-pop">
      <Retour />
      <h1 className="t-display" style={{ fontSize: 26, margin: '0 0 6px' }}>Votre bon d’achat</h1>
      {partenaire.retrocom ? (
        <p className="t-stone" style={{ fontSize: 14.5, lineHeight: 1.6, margin: '0 0 16px' }}>
          Sur chaque jouet que vous nous avez envoyé et que nous revendons, vous gagnez un pourcentage de son prix de vente,
          crédité automatiquement chaque lundi. Ce pourcentage dépend de la qualité de chaque lot : plus nous pouvons
          reconditionner de jouets, plus il est élevé. Votre taux actuel : <b style={{ color: 'var(--bleu)' }}>{Math.round((partenaire.tauxRetrocom || 0.1) * 100)} %</b>.
        </p>
      ) : null}
      {partenaire.retrocom && partenaire.paliersRetrocom ? <Paliers paliers={partenaire.paliersRetrocom} /> : null}

      <div className="card" style={{ padding: 20, display: 'flex', gap: 18, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div style={{ flex: '1 1 140px' }}>
          <div className="t-overline">Solde disponible</div>
          <div className="t-display" style={{ fontSize: 34, color: 'var(--rouge)' }}>{fmtEuro(partenaire.solde)}</div>
        </div>
        <div style={{ flex: '1 1 120px' }}>
          <div className="t-overline">Obtenu</div>
          <div style={{ fontWeight: 700, fontSize: 18 }}>{fmtEuro(credits)}</div>
        </div>
        <div style={{ flex: '1 1 120px' }}>
          <div className="t-overline">Utilisé</div>
          <div style={{ fontWeight: 700, fontSize: 18 }}>{fmtEuro(utilises)}</div>
        </div>
      </div>

      <h2 className="t-display" style={{ fontSize: 20, margin: '26px 0 10px' }}>Détail</h2>
      {bons.length ? (
        <div className="card" style={{ padding: '4px 18px' }}>
          {bons.map((b, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderTop: i ? '1px solid var(--bord)' : 'none' }}>
              <span style={{ color: b.montant > 0 ? 'var(--bleu)' : 'var(--stone)', flexShrink: 0 }}>
                {b.montant > 0 ? <Icons.plus size={18} /> : <Icons.wallet size={18} />}
              </span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 600 }}>{b.motif}</div>
                <div className="t-stone" style={{ fontSize: 12.5 }}>{fmtDate(b.date)}</div>
              </div>
              <div style={{ fontWeight: 800, fontSize: 15, whiteSpace: 'nowrap', color: b.montant > 0 ? 'var(--bleu)' : 'var(--stone)' }}>
                {b.montant > 0 ? '+ ' : '− '}{fmtEuro(Math.abs(b.montant))}
              </div>
            </div>
          ))}
        </div>
      ) : <div className="t-stone" style={{ fontSize: 14 }}>Aucun mouvement pour l’instant.</div>}
    </div>
  );
}
